module.exports = __webpack_public_path__ + "img/8_fineStaff_gcq.4ccae20b.png";